import { Phone, Zap } from "lucide-react";

export default function TopBar() {
  return (
    <div data-testid="top-announcement-bar" className="fixed top-0 left-0 right-0 z-[60] bg-gradient-to-r from-amber-500 via-yellow-500 to-amber-500 text-black">
      <div className="max-w-7xl mx-auto px-3 sm:px-6 md:px-12 flex items-center justify-between h-10 gap-2">
        <div className="flex items-center gap-2 min-w-0">
          <Zap className="w-3.5 h-3.5 flex-shrink-0 hidden sm:block" />
          <p className="text-[12px] sm:text-xs md:text-sm font-semibold leading-tight truncate">
            <span className="sm:hidden">Looking for a Red Seal certified Electrician?</span>
            <span className="hidden sm:inline">We provide professional electrical services delivered by Red Seal certified electricians.</span>
          </p>
        </div>
        <a
          href="tel:+17783220801"
          data-testid="topbar-call-btn"
          className="flex items-center gap-1.5 bg-black text-amber-400 font-bold text-[11px] sm:text-xs px-3 sm:px-4 py-1.5 rounded-full hover:bg-gray-900 transition-colors flex-shrink-0 whitespace-nowrap"
        >
          <Phone className="w-3 h-3" />
          <span>Call Now</span>
        </a>
      </div>
    </div>
  );
}
